// extracted by mini-css-extract-plugin
export var link = "styles-module--link--f5e4a";
export var link_active = "styles-module--link_active--31ca4";
export var shapeNavigation = "styles-module--shapeNavigation--c2e73";